module.exports = __webpack_public_path__ + "static/media/icon-car.24a932de.svg";